import type { AiEntry } from '~/api/endpoints'

/** What the AI tab is holding, so the dialog can tell whether closing loses anything. */
export interface AiState {
  /** The photo, as it will be sent, or null while there is none. */
  image: string | null
  description: string
  /** The answer under review, or null while still asking. */
  answer: AiEntry[] | null
  /** What the AI would call the meal the answer makes. */
  name: string | null
  details: string
}

export const EMPTY_AI_STATE: AiState = {
  image: null,
  description: '',
  answer: null,
  name: null,
  details: '',
}

/** Whether leaving asking would lose a photo, a description, or an answer not yet logged. */
export function aiDirty(state: AiState): boolean {
  return state.image !== null || state.description.trim() !== '' || state.answer !== null
}
